export default "__VITE_ASSET__CZwB1htv__"